import React from 'react';
import ContractRow from './ContractRow';
import { CONTRACTS, LINKS } from '../../data/site';

const STATS = [
  { num: '2', lbl: 'CHAINS' },
  { num: 'ERC-20', lbl: 'ARBITRUM' },
  { num: 'SPL', lbl: 'SOLANA' },
];

const Contracts = ({ alwaysShowTitle = false }) => (
  <div id="contracts">
    <div className={alwaysShowTitle ? 'mb-3' : 'mb-3 hidden lg:block'}>
      <h2 className="text-[26px] font-bold leading-tight lg:text-[30px]">📜 Contracts</h2>
      <p className="mt-1 text-base font-medium">Official addresses. Always double-check before you swap.</p>
    </div>

    <div className="grid gap-2.5 lg:gap-3.5">
      <ContractRow chain={CONTRACTS.arbitrum} showExplorer />
      <ContractRow chain={CONTRACTS.solana} showExplorer />
    </div>

    <div className="mt-6 grid grid-cols-3 gap-2.5 lg:mt-8 lg:gap-3.5">
      {STATS.map((s) => (
        <div key={s.lbl} className="rounded-2xl border-[3px] border-ink bg-sun px-1.5 py-3 text-center shadow-hard lg:py-5">
          <div className="text-xl font-bold lg:text-[26px]">{s.num}</div>
          <div className="text-[11px] font-semibold tracking-[0.5px] lg:text-xs">{s.lbl}</div>
        </div>
      ))}
    </div>
    <p className="mt-3 text-center text-xs font-medium lg:text-sm">
      Live price, market cap and rank:{' '}
      <a className="font-semibold underline" href={LINKS.coingecko} target="_blank" rel="noopener noreferrer">
        CoinGecko ↗
      </a>
    </p>
  </div>
);

export default Contracts;
